module.exports = {
  available: false,
  hideLink: false,
  showTerms: true,
  termsVersion: "v2",
  customSplashBanner: "",
  customSplashBannerColor: "",
  slug: "maui2021",
  name: "Maui",
  year: "2021",
  region: "Hawaii",
  country: "United States",
  location: "Maui, Hawaii",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: true,
  useHawaiiPricing: true,
  useHawaiiPhoneGate: false,
  useHawaiiSplashMasking: true,
  useHawaiiTripMasking: true,
  soldOutPercent: 0,
  soldOutPercentHawaii: 0,
  soldOutReferralTrip: "",
  soldOutReferralText: "",
  banners: [""],
  thinBar1: "",
  thinBar2: "",
  saleEndsAt: "",
  onLocationPricingAvailable: false,
  onLocationPricingCutoff: "2021-02-16T23:00:00",
  onLocationMessage: "",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: true,
  requireFirstNameForNewsletterFooter: false,
  requireLastNameForNewsletterFooter: false,
  allowPayChangeDuringCheckout: false,
  dates: "May 30 - June 5, 2021",
  timeZone: "HST",
  startTime: "7:00 PM (HST)",
  checkInDay: "Sunday",
  checkInDate: "May 30, 2021",
  checkInTime: "4:00 PM (HST)",
  arrivePriorTo: "4:00 PM (HST)",
  checkOutDay: "Saturday",
  checkOutDate: "June 5, 2021",
  checkOutTime: "12:00 PM (HST)",
  disableRoomPricing: false,
  disableMonthlyPaymentOption: true,
  maxSubMonths: 20,
  useMaxSubMonthsCutoff: "09-28-2019",
  availabilityCutoff: "05-28-2021",
  departureAirport: "Kahului",
  departureAirCode: "OGG",
  venue: "Fairmont Kea Lani",
  venueSlug: "fairmont-kea-lani",
  homeVideoId: 517500738,
  requestBrochureCategoryID: "9aa50add7a",
  finalDetailsFormHash: "z3nldhd06d7wmt",
  finalDetailsFormEnabled: true,
  postponementFormHash: "",
  postponementFormEnabled: false,
  postponementFormExtHash: "",
  postponementFormExtEnabled: false,
  transferFormHash: {
    kauai2021: "zue2r101pss8j7",
    cancun2021: "z6iccvq1s1sww2",
  },
  transferFormEnabled: true,
  transferMapping: {
    kauai2021: {
      standard: "fairmont",
      "standard-king": "fairmont-king",
      pool: "partial-ocean",
      "pool-king": "partial-ocean-king",
      "partial-ocean": "ocean",
      "partial-ocean-king": "ocean-king",
      "deluxe-ocean": "deluxe-ocean",
      "deluxe-ocean-king": "deluxe-ocean-king",
      "standard-suite": "ohana-suite",
      "ocean-view-suite": "kolhana-suite",
      "deluxe-ocean-view-suite": "villa",
    },
    cancun2021: {
      discounts: {
        a: 500,
      },
      standard: {
        standard: 500,
        "partial-ocean": 1000,
        ocean: 1500,
      },
      "standard-king": {
        "standard-king": 0,
        "partial-ocean-king": 1000,
        "ocean-king": 1500,
      },

      "ocean-view": {
        standard: 500,
        "partial-ocean": 1000,
        ocean: 1500,
      },
      "ocean-view-king": {
        "standard-king": 500,
        "partial-ocean-king": 1000,
        "ocean-king": 1500,
      },
      "ocean-view-king-higherfloor": {
        "standard-king": 0,
        "partial-ocean-king": 500,
        "ocean-king": 1000,
      },

      oceanfront: {
        fairmont: 0,
        "partial-ocean": 800,
        "deluxe-ocean": 1800,
      },

      "oceanfront-higherfloor": {
        "partial-ocean": 0,
        ocean: 800,
        "deluxe-ocean": 1400,
      },

      "oceanfront-king": {
        "fairmont-king": 0,
        "partial-ocean-king": 800,
        "deluxe-ocean-king": 1800,
      },

      "club-oceanview": {
        ocean: 0,
      },

      "club-oceanview-king": {
        "ocean-king": 0,
      },

      "club-oceanfront": {
        "deluxe-ocean": 0,
      },
      "club-oceanfront-king": {
        "deluxe-ocean-king": 0,
      },
      "ocean-view-suite": {
        "ocean-king": 0,
      },
      "oceanfront-suite": {
        "deluxe-ocean-king": 0,
      },
      "club-ocean-view-suite": {
        "kolhana-suite": 0,
      },
      "club-oceanfront-suite": {
        "kolhana-suite": 0,
      },
      "club-master-suite": {
        "kolhana-suite": 0,
      },
      "ritz-carlton-suite": {
        villa: 0,
      },
    },
  },
  mainPageModal: {
    enabled: true,
    title: "",
    message: "",
    button: {
      text: "MAUI 2021",
      path: "/maui2021",
    },
  },
  tripPageModal: {
    enabled: false,
    dismissible: false,
    title: "",
    messageAlignment: "left",
    message: `
    `,
  },
  mapUrl:
    "https://www.google.com/maps?q=Fairmont+Kea+Lani&rlz=1C5CHFA_enUS936US939&um=1&ie=UTF-8&sa=X&ved=2ahUKEwjbsIrL6-ruAhXjGjQIHaOtCs4Q_AUoAXoECBoQAw",
  perks: [
    "7 Days / 6 Nights Fairmont Kea Lani, Maui Accommodations",
    "$48 Daily Resort Fee Per Person (Self-Parking, High-Speed Internet, In-Suite Bottled Water for Two Replenished Daily, One hour snorkel equipment (two sets per suite per day, resort use only), Pool and Beach Amenities including Sunscreen and After Sun Care, Hawaiian Canoe Experience, Weekly Cultural Activities)",
    "Fresh floral lei greeting upon arrival",
    "Everlasting Tours On-Location Staff",
    "Entertainment Wristbands ($500 value per person, included!)",
  ],
  subPerks: [
    "Speaking Sessions with Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
  ],
  lineup: [
    {
      key: "newsboys",
      kind: "artist",
      name: "Newsboys",
      nameFirst: "Newsboys",
      nameLast: "",
    },
    {
      key: "stevencurtischapman",
      kind: "artist",
      name: "Steven Curtis Chapman",
      nameFirst: "Steven Curtis",
      nameLast: "Chapman",
    },
    {
      key: "karenkingsbury",
      kind: "speaker",
      name: "Karen Kingsbury",
      nameFirst: "Karen",
      nameLast: "Kingsbury",
    },
    {
      key: "garythomas",
      kind: "speaker",
      name: "Gary Thomas",
      nameFirst: "Gary",
      nameLast: "Thomas",
    },
    {
      key: "kimwalkersmith",
      kind: "artist",
      name: "Kim Walker-Smith",
      nameFirst: "Kim",
      nameLast: "Walker-Smith",
    },
    {
      key: "marybethchapman",
      kind: "speaker",
      name: "Mary Beth Chapman",
      nameFirst: "Mary Beth",
      nameLast: "Chapman",
    },
  ],
  itinerary: [
    {
      name: "Sun",
      body:
        "\
        <p>\
          <strong>Day 1 | May 30</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>\
            Resort Check-in & LOVESONG Registration\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Grand Opening with Troy Tyler<br />\
          Kim Walker-Smith Performance</strong>\
        </p>\
      ",
    },
    {
      name: "Mon",
      body:
        "\
        <p>\
          <strong>Day 2 | May 31</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship with Adam Agee<br />\
            Gary Thomas Speaking Session 1 & 2\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – LOVESONG Gala*</strong>\
        </p>\
      ",
    },
    {
      name: "Tue",
      body:
        "\
        <p>\
          <strong>Day 3 | June 1</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship with Kim Walker-Smith<br />\
            Gary Thomas Speaking Session 3\
            Karen Kingsbury Speaking Session 1<br />\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Hawaiian Nights Social*</strong>\
        </p>\
      ",
    },
    {
      name: "Wed",
      body:
        "\
        <p>\
          <strong>Day 4 | June 2</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Karen Kingsbury Speaking Session 2</strong><br />\
          <strong>Mary Beth Chapman Speaking Session</strong><br />\
          <strong>Steven Curtis Chapman Performance</strong>\
        </p>\
      ",
    },
    {
      name: "Thu",
      body:
        "\
        <p>\
          <strong>Day 5 | June 3</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Optional Activity – LOVESONG Interactive*</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>\
      ",
    },
    {
      name: "Fri",
      body:
        "\
        <p>\
          <strong>Day 6 | June 4</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Worship Session</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Gary Thomas Speaking Session 4</strong><br />\
          <strong>Newsboys Performance</strong>\
        </p>\
      ",
    },
    {
      name: "Sat",
      body:
        "\
        <p>\
          <strong>Day 7 | June 5</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Resort Checkout</strong>\
        </p>\
      ",
    },
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [],
  roomsLabel: "Suites",
  suitesLabel: "Signature Suites",
  roomUpgradeLabel: "Upgrade to a Signature Suite",
  rooms: {
    standard: {
      key: "standard",
      name: "Standard Suite",
      kind: "room",
      trip: "maui2021",
      upsell: "partial-ocean",
      prices: {
        default: 5198,
        hawaii: 4598,
        onlocation: 4598,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      hideFromBooking: false,
      note: "",
      image: "/images/rooms/maui2021-fairmont.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with limited baseline view from large private lanai, Double/Double or one King (bedding type not guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more...",
    },
    "standard-king": {
      key: "standard-king",
      name: "Standard Suite - King Guaranteed",
      kind: "room",
      trip: "maui2021",
      upsell: "partial-ocean-king",
      prices: {
        default: 5598,
        hawaii: 4998,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      hideFromBooking: false,
      note: "",
      image: "/images/rooms/maui2021-fairmont-king.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with limited baseline view from large private lanai, one King (bedding type guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more...",
    },
    fairmont: {
      key: "fairmont",
      name: "Fairmont Suite",
      kind: "room",
      trip: "maui2021",
      upsell: "partial-ocean",
      prices: {
        default: 5598,
        hawaii: 4998,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-fairmont.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with views of neighboring streets from large private lanai, Double/Double or one King (bedding type not guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "fairmont-king": {
      key: "fairmont-king",
      name: "Fairmont Suite - King Guaranteed",
      kind: "room",
      trip: "maui2021",
      upsell: "partial-ocean-king",
      prices: {
        default: 5998,
        hawaii: 5598,
        onlocation: 5398,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-fairmont-king.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with views of neighboring streets from large private lanai, one King (bedding type guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "partial-ocean": {
      key: "partial-ocean",
      name: "Partial Ocean View Suite",
      kind: "room",
      trip: "maui2021",
      upsell: "ocean",
      prices: {
        default: 6198,
        hawaii: 5798,
        onlocation: 5398,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-partial-ocean.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with partial or angled ocean views from large private lanai, Double/Double or one King (bedding type not guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "partial-ocean-king": {
      key: "partial-ocean-king",
      name: "Partial Ocean View Suite - King Guaranteed",
      kind: "room",
      trip: "maui2021",
      upsell: "ocean-king",
      prices: {
        default: 6598,
        hawaii: 6198,
        onlocation: 5798,
      },
      extraNightPrices: {
        default: 600,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-partial-ocean-king.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with partial or angled ocean views from large private lanai, one King (bedding type guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    ocean: {
      key: "ocean",
      name: "Ocean View Suite",
      kind: "room",
      trip: "maui2021",
      upsell: "deluxe-ocean",
      prices: {
        default: 6598,
        hawaii: 6198,
        onlocation: 5998,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-ocean.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with ocean views from private lanai, Double/Double or one King (bedding type not guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "ocean-king": {
      key: "ocean-king",
      name: "Ocean View Suite - King Guaranteed",
      kind: "room",
      trip: "maui2021",
      upsell: "",
      prices: {
        default: 6998,
        hawaii: 6598,
        onlocation: 6398,
      },
      extraNightPrices: {
        default: 700,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-ocean-king.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with ocean views from private lanai, one King (bedding type guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "deluxe-ocean": {
      key: "deluxe-ocean",
      name: "Deluxe Ocean View Suite",
      kind: "room",
      trip: "maui2021",
      upsell: "deluxe-ocean-king",
      prices: {
        default: 6998,
        hawaii: 6798,
        onlocation: 6398,
      },
      extraNightPrices: {
        default: 700,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-deluxe-ocean.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with ocean and sunset views from suite and private lanai, Double/Double or one King (bedding type not guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "deluxe-ocean-king": {
      key: "deluxe-ocean-king",
      name: "Deluxe Ocean View Suite - King Guaranteed",
      kind: "room",
      trip: "maui2021",
      upsell: "",
      prices: {
        default: 7598,
        hawaii: 7198,
        onlocation: 6798,
      },
      extraNightPrices: {
        default: 750,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "",
      image: "/images/rooms/maui2021-deluxe-ocean-king.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite with ocean and sunset views from suite and private lanai, one King (bedding type guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "ohana-suite": {
      key: "ohana-suite",
      name: "Ohana Suite",
      kind: "suite",
      trip: "maui2021",
      upsell: "",
      prices: {
        default: 8598,
        hawaii: 7998,
        onlocation: 8598,
      },
      extraNightPrices: {
        default: 1000,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/maui2021-ohana-suite.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 1100 sqft one-bedroom suite with views of lush tropical gardens from large private lanai, one King (bedding type guaranteed), oversized 5-piece marble bathroom with deep soaking tub and walk-in shower, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    "signature-ocean-suite-king": {
      key: "signature-ocean-suite-king",
      name: "Signature Ocean Suite - King Guaranteed",
      kind: "suite",
      trip: "maui2021",
      upsell: "kolhana-suite",
      prices: {
        default: 9998,
        hawaii: 9598,
        onlocation: 8598,
      },
      extraNightPrices: {
        default: 1000,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "1 Remaining",
      image: "/images/rooms/maui2021-deluxe-ocean-king.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 860 sqft one-bedroom suite located on top 2 floors with the best ocean and sunset views from suite and private lanai, one King (bedding type guaranteed), marble bathroom, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },

    "kolhana-suite": {
      key: "kolhana-suite",
      name: "Signature Kolhana Suite",
      kind: "suite",
      trip: "maui2021",
      upsell: "",
      prices: {
        default: 12998,
        hawaii: 9598,
        onlocation: 12598,
      },
      extraNightPrices: {
        default: 1250,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "",
      image: "/images/rooms/maui2021-kolhana-suite.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 1100 sqft one-bedroom suite with spectacular panoramic ocean and sunset views from expansive wrap-around corner lanai, one King (bedding type guaranteed), oversized 5-piece marble bathroom with deep soaking tub and walk-in shower, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
    villa: {
      key: "villa",
      name: "Signature Ocean View Villa",
      kind: "suite",
      trip: "maui2021",
      upsell: false,
      prices: {
        default: 14998,
        hawaii: 9998,
        onlocation: 14598,
      },
      extraNightPrices: {
        default: 2000,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      hideFromBooking: true,
      note: "",
      image: "/images/rooms/maui2021-villa.jpg",
      header: "/images/rooms/resort-top-photo.jpg",
      description:
        "Spacious 1800 sqft two-bedroom suite with spectacular panoramic ocean and sunset views steps away from Polo Beach.  This impressive villa offers a large private lanai, one King (bedding type guaranteed), a full gourmet kitchen, oversized 5-piece marble bathroom with deep soaking tub and walk-in shower, foyer pantry area with granite countertop, compact chiller, microwave, kettle, Keurig coffee maker, and more…",
    },
  },
};



// WEBPACK FOOTER //
// ./lib/trips/maui2021.js